import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ComboDropdownKhoaThi from '../components/form/ComboDropdownKhoaThi'
import Table from '../components/layout/Table'
import tuHuyProcessor from '../processor/tuHuyProcessor'

export default function TuHuy() {
  const [soLuongBanSao, setSoLuongBanSao] = useState(0)
  const [soLuongDaDuyet, setSoLuongDaDuyet] = useState(0)
  const [soLuongChuaDuyet, setSoLuongChuaDuyet] = useState(0)
  const [soLuongImport, setSoLuongImport] = useState(0)
  const toast = useSelector((store) => store.notify.toast)

  const khoaThiId = useSelector((state) => state.khoaThi.id)

  const load = async () => {
    const banSao = await tuHuyProcessor.countBanSaoByKhoaThi(khoaThiId)
    setSoLuongBanSao(banSao)
    const daDuyet = await tuHuyProcessor.countDaDuyetByKhoaThi(khoaThiId)
    setSoLuongDaDuyet(daDuyet)
    const chuaDuyet = await tuHuyProcessor.countChuaDuyetByKhoaThi(khoaThiId)
    setSoLuongChuaDuyet(chuaDuyet)
    const imported = await tuHuyProcessor.countImportByKhoaThi(khoaThiId)
    setSoLuongImport(imported)
  }

  useEffect(() => {
    load()
  }, [khoaThiId])
  const data = [
    { name: 'Tổng số bản sao', value: soLuongBanSao, action: 'xoaBanSao' },
    { name: 'Tổng số đã duyệt', value: soLuongDaDuyet, action: 'xoaDaDuyet' },
    { name: 'Tổng số chưa duyệt', value: soLuongChuaDuyet, action: 'xoaChuaDuyet' },
    { name: 'Tổng số import', value: soLuongImport, action: 'xoaImport' },
  ]
  return (
    <>
      <Toolbar right={<ComboDropdownKhoaThi />} />
      <Table
        data={data}
        column={[
          { name: 'Tên', value: 'name' },
          { name: 'Giá trị', value: 'value' },
          {
            name: '',
            value: 'action',
            render: (item) => (
              <Button
                icon="pi pi-trash"
                className="p-button-rounded p-button-danger"
                onClick={async () => {
                  const rs = await tuHuyProcessor[item.action](khoaThiId)
                  toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
                  await load()
                }}
              />
            ),
          },
        ]}
      />
    </>
  )
}
